export default "__VITE_ASSET__CxBy6xo9__"